import { AIAgentResult } from '../../../models/AIAgent'
import React, { ComponentType } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetMeQuery } from '../../../store/user/user'
import { useGetFeatureByIdQuery } from '../../../store/ai/ai'
import { useGetAllScorecardsQuery } from '../../../store/ai/scorecard'
import { AIAgentLoader } from '../AIAgentLoader/AIAgentLoader'
import { Container, Row } from 'react-bootstrap'
import { FormResult } from '../../../apps/professional-app/fa/MeetingSummary/FormFills/FormResult'
import { useGetExternalUserByIdQuery } from '../../../store/externalUser/externalUser'

interface FormFillBodyProps {
  isLoading: boolean
  formResult: AIAgentResult
  contactId: string
  aiFeatureId: string
  FooterComponent: ComponentType
}

export const FormFillBody: React.FC<FormFillBodyProps> = ({ isLoading, formResult, contactId, aiFeatureId, FooterComponent }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId: accountId })

  const { data: userData } = useGetExternalUserByIdQuery({
    accountId: accountId,
    userId: contactId,
  })
  const { data: featureData } = useGetFeatureByIdQuery({
    accountId: accountId,
    aiFeatureId: aiFeatureId,
  })

  const { data: scorecardData } = useGetAllScorecardsQuery({
    accountId: accountId,
    aiFeatureIds: aiFeatureId,
  })

  if (isLoading || !featureData || !userData || !scorecardData || !scorecardData.data) {
    return <AIAgentLoader withChat={false} longLoadingMessage='Filling a form can take up to 45 seconds to generate, please hold on' />
  }

  const saveEventDetails = {
    formId: aiFeatureId,
    contactId: currentUser?.id,
    formType: 'contact',
  }

  const exportEventDetails = {
    formId: aiFeatureId,
    type: 'formResult',
    contactId: currentUser?.id,
    formType: 'contact',
  }

  return (
    <Container>
      <Row className='py-4'>
        <FormResult
          formResult={formResult}
          user={userData.data}
          aiFeature={featureData.data}
          scorecard={scorecardData.data[0]}
          currentUser={currentUser ?? null}
          saveEventDetails={saveEventDetails}
          exportEventDetails={exportEventDetails}
        />
      </Row>
      <Row className='py-4'>
        <FooterComponent />
      </Row>
    </Container>
  )
}
